// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__17c4s","itemTitle":"ClientEmergencyInfo_itemTitle__2X2H7","itemText":"ClientEmergencyInfo_itemText__25E2A"};